/** Custom event to expand the Ameyo calling panel from other screens (e.g. AGENT_NOT_LOGGED_IN). */
export const AMEYO_EXPAND_TOOLBAR_EVENT = "ameyo:expand-toolbar";

export function requestAmeyoToolbarExpand(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(AMEYO_EXPAND_TOOLBAR_EVENT));
}
